import articlesApi from '@/services/api/articles.js';

export default {
  namespaced: true,
  state: {
    articles: [],
    article: {},
  },
  getters: {
    articles: state => {
      return state.articles.map(item => ({
        id: item.id,
        type: item.type,
        ...item.data,
        created_at: item.created_at,
        updated_at: item.updated_at,
      }));
    },
    article: state => state.article,
  },
  mutations: {
    setArticles: (state, articles) => {
      state.articles = articles;
    },
    setArticle: (state, article) => {
      state.article = article;
    },
    addArticle: (state, article) => {
      state.articles.push(article);
    },
    updateArticle: (state, updatedArticle) => {
      const index = state.articles.findIndex(article => article.id === updatedArticle.id);
      if (index !== -1) {
        state.articles[index] = updatedArticle;
      }
    },
    removeArticle: (state, articleId) => {
      state.articles = state.articles.filter(article => article.id !== articleId);
    },
  },
  actions: {
    loadArticles ({ commit }, options = {}) {
      return new Promise((resolve, reject) => {
        articlesApi.getArticles(options)
          .then(({ data }) => {
            commit('setArticles', Array.isArray(data.data) ? data.data : []);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getArticle ({ commit }, id) {
      return new Promise((resolve, reject) => {
        articlesApi.getArticle(id)
          .then(({ data }) => {
            commit('setArticle', data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    createArticle ({ commit }, articleData) {
      return new Promise((resolve, reject) => {
        articlesApi.createArticle(articleData)
          .then((response) => {
            if (response && response.data) {
              commit('addArticle', response.data);
            }
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateArticle ({ commit }, { id, data }) {
      return new Promise((resolve, reject) => {
        articlesApi.updateArticle(id, data)
          .then((response) => {
            if (response && response.data) {
              commit('updateArticle', response.data);
            }
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    deleteArticle ({ commit }, id) {
      return new Promise((resolve, reject) => {
        articlesApi.deleteArticle(id)
          .then((response) => {
            commit('removeArticle', id);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    deleteAllArticles ({ commit, state }) {
      return new Promise((resolve, reject) => {
        const deletePromises = state.articles.map(article =>
          articlesApi.deleteArticle(article.id),
        );
        Promise.all(deletePromises)
          .then(() => {
            commit('setArticles', []);
            resolve();
          })
          .catch(e => reject(e));
      });
    },
  },
};
